import { required, email, minLength } from '@vuelidate/validators'

export const UserValidation = {
    name: { required },
    phone: { required, minLength: minLength(18) },
    email: { required, email },
    password: { required, minLength: minLength(6) },
}
